import { createContext, useContext, type ReactNode } from "react";

const StaticDemoModeContext = createContext(false);

export function StaticDemoModeProvider({ children }: { children: ReactNode }) {
  return <StaticDemoModeContext.Provider value>{children}</StaticDemoModeContext.Provider>;
}

export function useStaticDemoMode() {
  return useContext(StaticDemoModeContext);
}
